<template>
  <layoutContainer>
    <div class="social-security-page">
      <!-- 主要内容区域 -->
      <div class="main-content">
          <video
            id="social-security-player"
            width="1200"
            height="675"
            preload="auto"
            playsinline
            webkit-playsinline
            controls
          ></video>
        <div v-if="videoName && hasVideo" class="video-title">
          <h1>{{ videoName }}</h1>
        </div>
        <!-- <div class="tips" v-if="type !== 'socialExample'">(本页仅您和运营人员可见)</div> -->
      </div>
    </div>
  </layoutContainer>
</template>

<script>
import {getSocialSecurityVideo} from '@/api/socialSecurity'

export default {
  name: 'SocialSecurityPage',
  data() {
    return {
      searchKeyword: '',
      selectedFile: null,
      selectedFileName: '',
      uploading: false,
      uploadProgress: 0,
      showUploadSuccess: false,
      hasVideo: false,
      videoInfo: {
        appId: '',
        psign: '',
        existsUploadVideo: false,
        socialSecurityCloudFileId: ''
      },
      player: null,
      consultantId: null,
      // 视频上传相关
      videoFile: null,
      applyId: null,
      isDel: false,
      // 允许的视频格式
      allowedFormats: '.mp4,.ts,.flv,.wmv,.asf,.rm,.rmvb,.mpg,.mpeg,.3gp,.mov,.webm,.mkv,.avi',
      type: '',
      // 通用视频播放参数
      cloudVideoId: null,
      videoName: ''
    }
  },
  created() {
    // 从URL参数获取视频播放所需的参数
    const appId = this.$route.query.appId
    const psign = this.$route.query.psign
    const socialSecurityCloudFileId = this.$route.query.cloud_video_id || this.$route.query.cloudFileId
    const fileName = this.$route.query.fileName || this.$route.query.video_name || ''
    this.type = this.$route.query.type || ''
    this.consultantId = this.$route.query.consultantId || null
    // 如果四个参数都存在，直接播放视频
    if (appId && psign && socialSecurityCloudFileId) {
      this.videoInfo = {
        appId,
        psign,
        socialSecurityCloudFileId,
        existsUploadVideo: true
      }
      this.videoName = fileName
      this.hasVideo = true
      this.$nextTick(() => {
        this.initVideoPlayer()
      })
      return
    }

    // 参数不完整，提示错误
    // this.$message.error('视频参数不完整，无法播放')
    // this.$router.push('/')
  },
  mounted() {
    this.initVideoPlayer()
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    // 初始化视频播放器
    initVideoPlayer() {
      if (!this.hasVideo || !this.videoInfo.socialSecurityCloudFileId) return

      // 使用腾讯云播放器
      if (window.TCPlayer) {
        this.player = window.TCPlayer('social-security-player', {
          fileID: this.videoInfo.socialSecurityCloudFileId,
          appID: this.videoInfo.appId,
          psign: this.videoInfo.psign,
          // width: 1230,
          // height: 675,
          autoplay: false,
          plugins: {
            ProgressMarker: true,
            ContextMenu: {
              statistic: true,
              levelSwitch: {
                open: true,
                switchingText: 'Start switching',
                switchedText: 'Switch success',
                switchErrorText: 'Switch fail'
              }
            }
          }
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.social-security-page {
  min-height: 100vh;
  background-color: #f5f5f5;

  .page-header {
    background: #fff;
    padding: 20px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .header-content {
      width: 1300px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .search-section {
        flex: 1;
        max-width: 500px;

        .search-input {
          .el-input__inner {
            border-radius: 20px;
            border: 1px solid #ddd;
          }
        }
      }

      .action-section {
        .publish-btn {
          background: #ff6b35;
          border-color: #ff6b35;
          border-radius: 20px;
          padding: 10px 20px;

          &:hover {
            background: #ff5722;
            border-color: #ff5722;
          }
        }
      }
    }
  }

  .main-content {
    width: 1300px;
    margin: 20px auto;
    // padding: 0 20px;

    .video-section {
      background: #fff;
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .video-container {
        position: relative;
        width: 100%;
        height: 675px;
        background: #000;
        border-radius: 8px;
        overflow: hidden;

        video {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .no-video-tip {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #999;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;

          i {
            font-size: 48px;
            margin-bottom: 10px;
          }

          p {
            margin: 0;
            font-size: 16px;
          }
        }
      }
    }

    .video-title {
      h1 {
        text-align: center;
        margin: 0;
        color: #000;
        font-size: 18px;
        font-weight: 500;
        font-size: 30px;
      }
      margin-top: 40px;
    }
    .tips {
      text-align: center;
      margin-top: 20px;
      color: #999;
      font-size: 16px;
    }
    .upload-section {
      background: #fff;
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .upload-container {
        display: flex;
        align-items: center;
        gap: 20px;

        .file-select {
          flex: 1;

          .file-input {
            .el-input__inner {
              cursor: pointer;
            }
          }
        }

        .upload-actions {
          display: flex;
          align-items: center;
          gap: 15px;

          .upload-btn {
            background: #ff6b35;
            border-color: #ff6b35;
            padding: 10px 20px;

            &:hover {
              background: #ff5722;
              border-color: #ff5722;
            }

            &:disabled {
              background: #ccc;
              border-color: #ccc;
              cursor: not-allowed;
            }
          }

          .upload-progress {
            display: flex;
            align-items: center;
            gap: 10px;
            min-width: 150px;

            span {
              font-size: 14px;
              color: #666;
              white-space: nowrap;
            }

            .progress-bar {
              flex: 1;
              min-width: 100px;
            }
          }
        }
      }
    }
  }
}

.upload-success-content {
  text-align: center;
  padding: 20px 0;

  .success-icon {
    font-size: 48px;
    color: #67c23a;
    margin-bottom: 15px;
  }

  p {
    margin: 0;
    font-size: 16px;
    color: #333;
  }
}

.dialog-footer {
  text-align: center;
}

// 响应式设计
@media (max-width: 768px) {
  .social-security-page {
    .main-content {
      padding: 0 10px;

      .video-section .video-container {
        height: 400px;
      }

      .upload-section .upload-container {
        flex-direction: column;
        align-items: stretch;

        .upload-actions {
          justify-content: center;
        }
      }
    }
  }
}
</style>
